import React from 'react';
import logo from "../../assets/Images/LoaderLogo.png";
import closeIcon from "../../assets/Images/Navbar/close.png";
import "./Authentication.css";

const AuthTypeSelector = ({ isSignup, setIsSignup, resetForm, closeModal }) => {
    return (
        <div className="docity-selection-modal">
            <div className="close-icon" onClick={closeModal} style={{ cursor: "pointer" }}>
                <img src={closeIcon} alt="Close" onClick={closeModal} />
            </div>
            {/* Logo Area */}
            <div className="docity-logo-area">
                <img src={logo} alt="DoCity Logo" className="logoImage" />
            </div>
            <div className="docity-auth-prompt">
                <p>Welcome! How would you like to proceed?</p>
            </div>
            {/* Button Group */}
            <div className="docity-minimal-nav">
                <div className="row">

                    <div className="col-md-6 mb-2">
                        <button
                            className={`docity-minimal-btn ${isSignup === "login" ? "active" : ""}`}
                            onClick={() => { setIsSignup("login"); resetForm(); }}
                        >
                            Login
                        </button>
                    </div>

                    <div className="col-md-6 mb-2">
                        <button
                            className={`docity-minimal-btn ${isSignup === "signup" ? "active" : ""}`}
                            onClick={() => { setIsSignup("signup"); resetForm(); }}
                        >
                            Register
                        </button>
                    </div>
                </div>




            </div>
        </div>
    );
};

export default AuthTypeSelector;